export default "__VITE_ASSET__ee5r8XKw__"